<!--调拨订单查看页面--->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 98%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <p v-show="lockuname" style="color: red"><span>操作人：</span>{{lockuname}}<span>正在操作</span>
        <span @click="unlock"
              style="color: blue;cursor: pointer;">&nbsp;解除锁定</span>
      </p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="print-table">
        <tr class="noborder" style="height: 26px" v-if="jinjia!=80">
          <td align="right">名&nbsp;&nbsp;&nbsp;称：</td>
          <td colspan="3">{{controlData.seedname}}</td>
          <td align="right" width="40">编&nbsp;&nbsp;&nbsp;码：</td>
          <td>{{controlData.seedcode}}</td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right" width="60">单&nbsp;&nbsp;&nbsp;号：</td>
          <td width="240">{{controlData.erpserial}}</td>
          <td align="right" width="60">登记日：</td>
          <td width="140">{{(controlData.adddate || "").substr(0, 10)}}</td>
          <td align="right" width="60">发货日：</td>
          <td>{{(controlData.accdate|| "").substr(0, 10)}}</td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right" width="60">发货仓：</td>
          <td width="140">{{controlData.cangkuname}}</td>
          <td align="right" width="40">地&nbsp;&nbsp;&nbsp;址：</td>
          <td colspan="3">{{controlData.cangkuaddress}} &nbsp; &nbsp;&nbsp;{{controlData.cangkutel}}</td>
          <!--<td align="right" width="60">电&nbsp;&nbsp;&nbsp;话：</td>-->
          <!--<td width="120">{{controlData.cangkutel}}</td>-->
        </tr>
        <tr class="noborder" style="height:26px">
          <td align="right">收货仓：</td>
          <td>{{controlData.cangkuname2}}</td>
          <td align="right">地&nbsp;&nbsp;&nbsp;址：</td>
          <td colspan="3">{{controlData.cangku1address}} &nbsp; &nbsp;&nbsp;{{controlData.cangku1tel}}</td>
          <!--<td align="right">电&nbsp;&nbsp;&nbsp;话：</td>-->
          <!--<td>{{controlData.cangku1tel}}</td>-->
        </tr>
        <tr class="noborder no-print" style="height: 26px;" v-if="opstatus=='fahuo'&&this.controlData.status==-10">
          <td align="right">物&nbsp;&nbsp;&nbsp;流：</td>
          <td>
            <el-select v-model="controlData.logisticsco" placeholder="请选择" size="mini">
              <el-option
                v-for="item in parameterData"
                :key="item.value"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </td>
          <td align="right">单&nbsp;&nbsp;&nbsp;号：</td>
          <td>
            <el-input v-model="controlData.logisticsnum" auto-complete="off" required="true" size="mini"
                      style="width: 180px;" placeholder="请填写快递单号"></el-input>
          </td>
        </tr>
        <tr class="noborder" style="height:26px" v-if="this.controlData.status==0||this.controlData.status==10">
          <td align="right">物&nbsp;&nbsp;&nbsp;流：</td>
          <td>{{controlData.logisticsco}}</td>
          <td align="right">单&nbsp;&nbsp;&nbsp;号：</td>
          <td>{{controlData.logisticsnum}}</td>
        </tr>
        <!--<tr class="noborder" v-if="opstatus&&jinjia!=40">-->
          <!--<td align="right">商品码：</td>-->
          <!--<td>-->
            <!--<el-input v-model="goodsbarcode" size="mini" @change="selectbarcode" ref="goodsbarcode"-->
                      <!--style="width: 125px"></el-input>-->
          <!--</td>-->
          <!--<td align="right"></td>-->
          <!--<td></td>-->
          <!--<td align="right"></td>-->
          <!--<td></td>-->
          <!--<td align="right"></td>-->
          <!--<td></td>-->
        <!--</tr>-->
        <tr v-show="showerweitable&&jinjia!=80">
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" v-if="isyinxin"
                   class="query-table">
              <tr>
                <td style="text-align: center;width: 50px">序号</td>
                <td style="text-align: center;min-width: 100px">厂家</td>
                <td style="text-align: center;min-width: 120px">注册证号</td>
                <td style="text-align: center;min-width: 100px">批次号</td>
                <td style="text-align: center;min-width: 70px">失效日期</td>
                <td style="text-align: center;min-width: 50px">球镜</td>
                <td style="text-align: center;min-width: 50px">柱镜</td>
                <td style="text-align: center;width: 50px">数量</td>
              </tr>
              <!--表头结束-->
              <tr v-for="(item,index) in tableData">
                <td style="text-align: center">{{index+1}}</td>
                <td>{{item["certorg"]}}</td>
                <td>{{item["certno"]}}</td>
                <td>{{item["batchno"]}}</td>
                <td>{{item["endtime"]?item["endtime"].split(' ')[0]:''}}</td>
                <td>{{item["Y"]}}</td>
                <td>{{item["X"]}}</td>
                <td>{{item["totalnumber"]}}</td>
              </tr>
            </table>
            <TwoDimensionalTable ref="referweibiao" v-else :needSetHeight="false" :needSetDisabled="false"
                                 :erweitable="erweitable"></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable&&jinjia!=80">
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="print-table">
              <tr>
                <td style="text-align: right;border:none;width: 10%">右眼：</td>
                <td style="text-align: left;border:none;width: 40%">
                  <TwoDimensionalTable ref="referweibiaoright" :needSetHeight="false" :needSetDisabled="false"
                                       :erweitable="erweitableright"></TwoDimensionalTable>
                </td>
                <td style="text-align: right;border:none;width: 10%">左眼：</td>
                <td style="text-align: left;border:none">
                  <TwoDimensionalTable ref="referweibiaoleft" :needSetHeight="false" :needSetDisabled="false"
                                       :erweitable="erweitableleft"></TwoDimensionalTable>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr v-show="showerweitable&&isshowbarcode&&jinjia!=80">
          <td colspan="6" style="border:none">
            <TwoDimensionalTable ref="barcodereferweibiao" :needSetHeight="false" :needSetDisabled="false"
                                 :erweitable="barcodeerweitable"></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable&&isshowbarcode&&jinjia!=80">
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="print-table">
              <tr>
                <td style="text-align: right;border:none;width: 10%">右眼：</td>
                <td style="text-align: left;border:none;width: 40%">
                  <TwoDimensionalTable ref="barcodereferweibiaoright" :needSetHeight="false" :needSetDisabled="false"
                                       :erweitable="barcodeerweitableright"></TwoDimensionalTable>
                </td>
                <td style="text-align: right;border:none;width: 10%">左眼：</td>
                <td style="text-align: left;border:none">
                  <TwoDimensionalTable ref="barcodereferweibiaoleft" :needSetHeight="false" :needSetDisabled="false"
                                       :erweitable="barcodeerweitableleft"></TwoDimensionalTable>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr v-if="jinjia==80||jinjia==40||isyinxin">
          <td colspan="6" style="text-align: right">总数：{{totalnumber}}
          <span style="padding-left: 30px" v-if="jinjia==80">总价：{{totalmoney}} &nbsp;</span></td>
        </tr>
        <tr v-show="jinjia==40">
          <td colspan="6">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table" v-if="isyinxin">
              <tr>
                <td style="text-align: center;width: 50px">序号</td>
                <td style="text-align: center;min-width: 140px">产品名称</td>
                <td style="text-align: center;min-width: 50px">编码</td>
                <td style="text-align: center;min-width: 100px">厂家</td>
                <td style="text-align: center;min-width: 120px">注册证号</td>
                <td style="text-align: center;min-width: 100px">批次号</td>
                <td style="text-align: center;min-width: 70px">失效日期</td>
                <td style="text-align: center;width: 50px">数量</td>
              </tr>
              <!--表头结束-->
              <tr v-for="(item,index) in tableData">
                <td style="text-align: center">{{index+1}}</td>
                <td>{{item["seedname"]}}</td>
                <td>{{item["seedcode"]}}</td>
                <td>{{item.baritem?item.baritem["certorg"]:''}}</td>
                <td>{{item.baritem?item.baritem["certno"]:''}}</td>
                <td>{{item.baritem?item.baritem["batchno"]:''}}</td>
                <td>{{(item.baritem&&item.baritem["endtime"])?item.baritem["endtime"].split(' ')[0]:''}}</td>
                <td>{{item["totalnumber"]}}</td>
              </tr>
            </table>
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table" v-else>
              <tr>
                <td style="text-align: center;width: 50px">序号</td>
                <td style="text-align: center;min-width: 140px">产品名称</td>
                <td style="text-align: center;min-width: 50px">编码</td>
                <td style="text-align: center;width: 50px">数量</td>
              </tr>
              <!--表头结束-->
              <tr v-for="(item,index) in tableData">
                <td style="text-align: center">{{index+1}}</td>
                <td>{{item["seedname"]}}</td>
                <td>{{item["seedcode"]}}</td>
                <td>{{item["totalnumber"]}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr v-if="jinjia==80">
          <td colspan="6">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"  class="query-table" v-if="!showframesub">
            <tr>
              <!--<td style="text-align: center;width: 50px">序号</td>-->
              <td style="text-align: center;min-width: 90px">产品名称</td>
              <td style="text-align: center;min-width: 50px">编码</td>
              <td style="text-align: center;min-width: 50px">型号</td>
              <td style="text-align: center;min-width: 50px">色号</td>
              <td style="text-align: center;min-width: 60px">零售价</td>
              <td style="text-align: center;width: 50px">数量</td>
              <td style="text-align: center;width: 140px" v-if="showtitle1=='none'">条码</td>
            </tr>
            <!--表头结束-->
           <template v-for="(tableD,tableIndex) in frameTable">
            <tr v-for="(item,index) in tableD.data">
              <!--<td style="text-align: center">{{index+1}}</td>-->
              <td>{{item["seedname"]}}</td>
              <td>{{item["seedcode"]}}</td>
              <td>{{item["model"]}}</td>
              <td>{{item["color"]}}</td>
              <td>{{item["costprice"]}}</td>
              <td>{{item["totalnumber"]}}</td>
              <td v-if="showtitle1=='none'"><div style="float: left;width: 98%" v-for="(co,index) in item.barcodes">{{co.c}}</div></td>
            </tr>
             <tr v-if="frameTable.length>1&&tableD.data.length>1">
               <!--<td style="text-align: center">{{index+1}}</td>-->
               <td colspan="4"><b>小计</b></td>
               <td><b>{{tableD.costprice?tableD.costprice.toFixed(2):''}}</b></td>
               <td><b>{{tableD.totalnumber?tableD.totalnumber.toFixed(0):''}}</b></td>
               <td v-if="showtitle1=='none'"></td>
             </tr>
           </template>
          </table>
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"  class="query-table" v-if="showframesub">
              <tr>
                <!--<td style="text-align: center;width: 50px">序号</td>-->
                <td style="text-align: center;min-width: 90px">品名</td>
                <td style="text-align: center;min-width: 60px">零售价</td>
                <td style="text-align: center;min-width: 60px">数量</td>
                <td style="text-align: center;min-width: 60px">合计</td>
              </tr>
              <!--表头结束-->
                <tr v-for="(item,index) in frameSubTable">
                  <!--<td style="text-align: center">{{index+1}}</td>-->
                  <td>{{item["seedname"]}}</td>
                  <td style="padding-left: 10px">{{item["costprice"]}}</td>
                  <td style="padding-left: 10px">{{item["totalnumber"]}}</td>
                  <td style="padding-left: 10px">{{item["costprice"]*item["totalnumber"]}}</td>
                </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder" style="height:26px">
          <td>说明：</td>
          <td colspan="5" style="text-align: left">
            <div v-html="getLiuYan(controlData.remark)"></div>
          </td>
        </tr>

        <tr class="noborder" style="height:26px">
          <td colspan="4">&nbsp;&nbsp;&nbsp;&nbsp;开单人员：{{controlData.uname}}</td>
          <td colspan="2">发货人员：{{controlData.logisticsuname}}</td>
        </tr>
      </table>
    </div>

    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" :loading="loading" v-if="opstatus=='fahuo'&&this.controlData.status==-10&&lock"
                 @click="fahuo()">确定发货
      </el-button>
      <el-button type="primary" :loading="loading" v-if="opstatus=='shouhuo'&&this.controlData.status==0"
                 @click="handlesaleCsagreementToVoid()">确定收货
      </el-button>
      <el-button type="primary" @click="print1" v-if="!lockuname"  icon="el-icon-printer"  size="mini">打印</el-button>
      <el-button type="primary" @click="printHuizhou" v-if="!lockuname&&jinjia==80"  icon="el-icon-printer"  size="mini">打印汇总单</el-button>
      <el-button type="primary" @click="loadExcel" v-if="!lockuname&&jinjia==80"  icon="el-icon-download"  size="mini">导出</el-button>
      <el-button @click="createBarcode" :loading="loading" v-if="jinjia==80" icon="el-icon-printer"  size="mini">打印条码</el-button>
      <span @click="printloglook" style="position: absolute;bottom: 8px;right: 10px">{{tips()}}</span>
    </div>

    <printlogList ref="printlogList"></printlogList>
    <HandlelogList ref="HandlelogList"></HandlelogList>

  </el-dialog>
</template>


<script>

  import {getDetail, receiveAllocation, saveAllocationStore} from '@/api/set/allocation';
  import {getRemark} from '@/plugin/ordercommon';
  import printlogList from '@/components/testorder/cstagreement/printlogList'
  import HandlelogList from '@/components/testorder/cstagreement/HandlelogList'
  import {save} from '@/api/order/printlog';
  import {printing} from '@/api/set/csagreement';
  import {getPrice} from '@/api/set/goodsprice';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getParameterDetail,detailglob} from '@/api/set/parameter';
  import {bardetail,createGoodsbarcode} from '@/api/set/jxcgoodsbarcode';
  import {saveData as logsaveData, getListData as logListData, lockremove} from '@/api/set/handlelog';
  import {batchSave} from '@/api/set/jxcstoregoodsbarcode';
  import {barcodePrint} from '@/api/file';

  export default {
    name: 'AllocationDetail',
    msg: '调拨单处理页面',
    data() {
      return {
        opstatus: '',
        formLabelWidth: '120px',
        row: {},
        dialogSeeVisible: false,
        loading: false,
        seedcode: "",
        unitguid: "",
        column: [],
        totalnumber:0,
        totalmoney:0,
        isdeliverShow: false,
        parameterData: [],
        controlData: {
          logisticsco: '',
          logisticsnum: '',
        },
        showtitle1: "none",
        isyinxin:false,
        erpserial: '',
        printData: [],//打印日志
        uname: '',//最新一条打印人员
        adddate: '',//最新一条打印时间
        erweitable: [],
        erweitableleft: [],
        erweitableright: [],
        barcodeerweitable: [],//商品条码扫码后用到
        barcodeerweitableleft: [],//商品条码扫码后用到
        barcodeerweitableright: [],//商品条码扫码后用到
        costpricebook: {},
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        barcodeBookContent: [],//商品条码扫码后用到
        barcodeBookContentLeft: [],//商品条码扫码后用到
        barcodeBookContentRight: [],//商品条码扫码后用到
        showzuoyoutable: false,
        showerweitable: false,
        goodsbar: {},//商品条码信息
        goodsbarcode: '',
        frameTable:[],
        frameSubTable:[],
        showframesub:false,
        isshowbarcode: false,//是否已经扫码确认数量
        barpackagesize: {},//商品条码光度信息
        lock: true,//锁定订单
        lockuname: '',//正在操作的人
        jinjia: '',
        tableData: [],
      }
    },
    methods: {
      padleft(ret,width,padChar) {
        while (ret.length < width) {
          ret = padChar + ret;
        }
        return ret;
      },
      createBarcode() {
        var number = 0;
        for (let i in this.tableData) {
          var tn = this.tableData[i].totalnumber | 0;
          var scancount = this.tableData[i].barcodes.length;

          if (tn <= 0) {
            this.$message({message: '数量必须大于0！', type: 'error'})
            return;
          }
          if (tn > scancount) {
            number += tn - scancount;
          }
        }

        this.loading = true;
        var saveBar = []
        var saveERPBar=[]
        if (number > 0) {
          //获取条码
          createGoodsbarcode({number: number}).then(response => {
            if (response.data.code == 0) {
              var codePre = response.data.codepre;
              var num = response.data.num;
              //item.model + item.color + '-' +
              for (let i in this.tableData) {
                var item = this.tableData[i];
                var tn = item.totalnumber | 0;
                var scancount = item.barcodes.length;
                for (let j = 0; j < tn - scancount; j++) {
                  var bc = codePre + this.padleft((num - number + 1).toString(), 3, '0');
                  item.barcodes.push({
                    c: bc
                  });
                  saveBar.push({
                    storegoodsbarcode: bc,
                    cangkucode: '',
                    inordernum: 'allocationbarcode',
                    seedcode: item.seedcode,
                    packagesize: item.packagesize
                  });
                  saveERPBar.push({
                    storegoodsbarcode: bc,
                    erpserial: item.erpserial,
                    formtype: '77',
                    detailunitguid: item.unitguid
                  });
                  number = number - 1;
                }
              }
              batchSave({caiGouRukuData: JSON.stringify(saveBar),erpbarcodes:JSON.stringify(saveERPBar)}).then(resSave => {//保存成功开始打印
                if (resSave.data.code == 0) {
                  this.barcodePDF();
                } else {
                  this.tableData = []
                  this.loading=false
                  this.$message({message: '条码生成失败，请重新选择！', type: 'error'})
                  return;
                }
              })
            }
          });
        } else {
          this.barcodePDF();
        }
      },
      barcodePDF() {
        var barcode = [];
        for (let i in this.tableData) {
          var item = this.tableData[i];
          for (let j in item.barcodes) {
            barcode.push({
              barcode: item.barcodes[j].c, seedcode: item.seedcode, model: item.model, color: item.color
            });
          }
        }
        barcodePrint(barcode, null);
        this.loading = false;
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        this.totalmoney = 0;
        for (let i in this.tableData) {
          this.totalnumber = this.totalnumber + parseInt(this.tableData[i].totalnumber)
          this.totalmoney = this.totalmoney + parseInt(this.tableData[i].totalnumber) * this.tableData[i].costprice;
        }
      },
      //处理日志
      handlelog(casestepname) {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = casestepname
        handlelog.remark = '调拨发货'
        logsaveData(handlelog).then(response => {
        })
      },
      //解除锁定
      unlock() {
        var casestepname = '调拨发货';
        lockremove({
          erpserial: this.erpserial
        }).then(response => {
          if (response.data.code == 0) {
            this.lock = true
            this.lockuname = ''
            //锁定功能(控制发起采购按钮)
            this.handlelog(casestepname);
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },
      //商品条码
      selectbarcode(val) {
        if (!val)
          return;
        this.goodsbarcode = '';
        this.barpackagesize = ''
        var obj = {
          barcode: val
        }
        bardetail(obj).then(response => {
          this.goodsbar = response.data.obj
          //商品不存在提示
          if (this.goodsbar == undefined) {
            this.$message({
              message: '条码无效',
              type: 'error'
            })
            return
          } else {
            this.isshowbarcode = true
            if (this.jinjia == 80) {//镜架扫码
              this.packagesize()
              return
            }
            this.barpackagesize = JSON.parse(this.goodsbar.packagesize)
            if (this.barpackagesize.P == undefined) {
              this.barpackagesize.P = 0
            }
            if (this.barpackagesize.type != undefined) {
              this.packagesize()
            } else {
              this.packagesize()
            }

          }

        })

      },
      //商品扫码数量确认
      packagesize() {
        var compare = true//控制 商品光度 不存在提示
        if (this.barpackagesize.type == "L") {
          for (let i in this.BookContentLeft) {
            var packagesizeleft = this.BookContentLeft[i]
            if (packagesizeleft.X == this.barpackagesize.X && packagesizeleft.Y == this.barpackagesize.Y) {
              compare = false
              //相同光度将上次扫码的数量获取出来
              if (this.barcodeBookContentLeft.length > 0) {
                for (let i in this.barcodeBookContentLeft) {
                  if (this.barcodeBookContentLeft[i].X == this.barpackagesize.X && this.barcodeBookContentLeft[i].Y == this.barpackagesize.Y) {
                    this.barpackagesize.P = this.barcodeBookContentLeft[i].P
                  }
                }
              }
              //对应的商品数量小于扫码数量提示已达上限，否则继续加1
              if (packagesizeleft.P > this.barpackagesize.P) {
                this.barpackagesize.P++
                this.barcodeBookContentLeft = []
                this.barcodeBookContentLeft.push(this.barpackagesize)
                this.$message({
                  message: JSON.stringify(this.barpackagesize) + '扫码成功',
                  type: 'success',
                })
              } else {
                this.$alert('该' + JSON.stringify(this.barpackagesize) + '已达到上限', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$message({
                      type: 'info',
                      message: `请继续扫码!`
                    });
                  }
                });
                this.goodsbarcode = ''
                return
              }
            }
          }
        } else if (this.barpackagesize.type == "R") {
          for (let i in this.BookContentRight) {
            var packagesizeright = this.BookContentRight[i]
            if (packagesizeright.X == this.barpackagesize.X && packagesizeright.Y == this.barpackagesize.Y) {
              compare = false
              //相同光度将上次扫码的数量获取出来
              if (this.barcodeBookContentRight.length > 0) {
                for (let i in this.barcodeBookContentRight) {
                  if (this.barcodeBookContentRight[i].X == this.barpackagesize.X && this.barcodeBookContentRight[i].Y == this.barpackagesize.Y) {
                    this.barpackagesize.P = this.barcodeBookContentRight[i].P
                  }
                }
              }
              //对应的商品数量小于扫码数量提示已达上限，否则继续加1
              if (packagesizeright.P > this.barpackagesize.P) {
                this.barpackagesize.P++
                this.barcodeBookContentRight = []
                this.barcodeBookContentRight.push(this.barpackagesize)
                this.$message({
                  message: JSON.stringify(this.barpackagesize) + '扫码成功',
                  type: 'success',
                })
              } else {
                this.$alert('该' + JSON.stringify(this.barpackagesize) + '已达到上限', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$message({
                      type: 'info',
                      message: `请继续扫码!`
                    });
                  }
                });
                this.goodsbarcode = ''
                return
              }
            }
          }
        } else if (this.jinjia == 80) {//镜架扫码
          var datalist = JSON.parse(JSON.stringify(this.tableData))
          for (let i in  datalist) {
            if (datalist[i].seedcode == this.goodsbar.seedcode) {
              if (datalist[i].totalnumber == datalist[i].P) {
                this.$alert('该商品' + datalist[i].seedname + '已达到上限', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$message({
                      type: 'info',
                      message: `请继续扫码!`
                    });
                  }
                });
                this.goodsbarcode = ''
                return
              }
              compare = false
              datalist[i].P = datalist[i].P + 1;
            }
          }
          this.tableData = JSON.parse(JSON.stringify(datalist))
        } else {
          for (let i in this.BookContent) {
            var packagesizes = this.BookContent[i]
            if (packagesizes.X == this.barpackagesize.X && packagesizes.Y == this.barpackagesize.Y) {
              compare = false
              //相同光度将上次扫码的数量获取出来
              if (this.barcodeBookContent.length > 0) {
                var flage = true;
                for (let i in this.barcodeBookContent) {
                  if (this.barcodeBookContent[i].X == this.barpackagesize.X && this.barcodeBookContent[i].Y == this.barpackagesize.Y) {
                    flage = false;
                    if (packagesizes.P > this.barcodeBookContent[i].P) {
                      this.barcodeBookContent[i].P++;
                      this.$message({
                        message: JSON.stringify(this.barpackagesize) + '扫码成功',
                        type: 'success',
                      })
                    } else {//扫码数量不得超过调拨数量
                      this.$alert('该' + JSON.stringify(this.barpackagesize) + '已达到上限', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                          this.$message({
                            type: 'info',
                            message: `请继续扫码!`
                          });
                        }
                      });
                      this.goodsbarcode = ''
                      return
                    }
                  }
                }
                //在barcodeBookContent没找到光度，进行添加
                if (flage) {
                  this.barpackagesize.P++
                  this.barcodeBookContent.push(this.barpackagesize)
                  this.$message({
                    message: JSON.stringify(this.barpackagesize) + '扫码成功',
                    type: 'success',
                  })
                }
              } else {//第一次扫码添加光度
                this.barpackagesize.P++
                this.barcodeBookContent.push(this.barpackagesize)
                this.$message({
                  message: JSON.stringify(this.barpackagesize) + '扫码成功',
                  type: 'success',
                })
              }
            }
          }
        }
        //商品光度 不存在提示
        if (compare) {
          this.$alert('商品光度不存在', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `请重新扫码!`
              });
            }
          });
          this.goodsbarcode = ''
          return
        }
        if (this.showzuoyoutable) {
          this.$refs.barcodereferweibiaoleft.initBookFix(this.barcodeBookContentLeft)
          this.$refs.barcodereferweibiaoright.initBookFix(this.barcodeBookContentRight)
        }
        if (this.showerweitable) {
          this.$refs.barcodereferweibiao.initBookFix(this.barcodeBookContent)
        }
      },
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "调拨单"
        return result
      },
      handlesaleCsagreementToVoid() {
        this.loading = true;
        //判断商品扫码确认调拨数量，是否一致
        if (this.showzuoyoutable) {
          if (this.barcodeBookContentLeft.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContentLeft) {
              barnumber += this.barcodeBookContentLeft[i].P
            }
            for (let j in this.BookContentLeft) {
              number += this.BookContentLeft[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
          if (this.barcodeBookContentRight.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContentRight) {
              barnumber += this.barcodeBookContentRight[i].P
            }
            for (let j in this.BookContentLeft) {
              number += this.BookContentRight[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
        } else if (this.showerweitable) {
          if (this.barcodeBookContent.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContent) {
              barnumber += this.barcodeBookContent[i].P
            }
            for (let j in this.BookContent) {
              number += this.BookContent[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
        }
        receiveAllocation({unitguid: this.controlData.unitguid}).then(response => {
          this.loading = false;
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              message: '确认收货成功!',
            });
            this.dialogSeeVisible = false
            this.$emit('bindGrid')
          } else {
            this.$message.error(response.data.msg)
          }
        })
      },
      message() {
        this.$message({
          message: '商品扫码数量确认不一致',
          type: 'error'
        })
      },
      fahuo() {
        if(!this.controlData.logisticsco){
          this.$message.error('请选择物流方式！')
          return
        }
        if(!this.controlData.logisticsnum&&!(this.controlData.logisticsco=='自取'||this.controlData.logisticsco=='配送')) {
          this.$message.error('请填写快递单号！')
          return
        }

        this.loading = true;
        //判断商品扫码确认调拨数量，是否一致
        if (this.showzuoyoutable) {
          if (this.barcodeBookContentLeft.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContentLeft) {
              barnumber += this.barcodeBookContentLeft[i].P
            }
            for (let j in this.BookContentLeft) {
              number += this.BookContentLeft[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
          if (this.barcodeBookContentRight.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContentRight) {
              barnumber += this.barcodeBookContentRight[i].P
            }
            for (let j in this.BookContentLeft) {
              number += this.BookContentRight[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
        } else if (this.showerweitable) {
          if (this.barcodeBookContent.length > 0) {
            var barnumber = 0;
            var number = 0;
            for (let i in this.barcodeBookContent) {
              barnumber += this.barcodeBookContent[i].P
            }
            for (let j in this.BookContent) {
              number += this.BookContent[j].P
            }

            if (barnumber < number) {
              this.message()
              this.loading = false
              return
            }
          }
        }
        saveAllocationStore({
          unitguid: this.controlData.unitguid,
          logisticsnum: this.controlData.logisticsnum,
          logisticsco: this.controlData.logisticsco
        }).then(response => {
          this.loading = false;
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              message: '确认发货成功!',
            });
            this.dialogSeeVisible = false
            this.$emit('bindGrid', true);
          } else {
            this.$message.error(response.data.msg)
          }
        });
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      loadExcel(){
        var data = []
        var rows = this.tableData
        for (let i = 0; i < rows.length; i++) {
          var obj = {}
          obj.seedname = rows[i].seedname
          obj.seedcode = rows[i].seedcode
          obj.model = rows[i].model
          obj.color = rows[i].color
          obj.totalnumber = rows[i].totalnumber
          data.push(obj)
        }

        var date = new Date();
        let header1 = ["商品名称", "商品代码", "型号", "色号", "数量"]
        let column1 = ["seedname", "seedcode", "model", "color", "totalnumber"]

        var name = '调拨单' + this.row.erpserial
        this.$exportExcel(header1, column1, data, name)
      },
      print1() {
        // window.print()
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
          this.printlogsave()
        })
      },
      printHuizhou(){
        this.showtitle1 = ""
        this.showframesub=true;
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
          this.showframesub=false;
        })
      },
      show() {
        this.dialogSeeVisible = true;
      },
      initData(row, opstatus) {
        this.initForm()
        this.frameTable=[]
        this.frameSubTable=[]//打印汇总单
        this.opstatus = opstatus;
        this.unitguid = row.unitguid
        this.erpserial = row.erpserial
        this.row = row;
        getDetail({unitguid: row.unitguid, erpserial: row.erpserial}).then(response => {
          this.controlData = response.data.obj;
          if (this.parameterData.length == 1)
            this.controlData.logisticsco = this.parameterData[0].name
          this.jinjia = this.controlData.filltemplate
          var bookcontent = response.data.obj.bookcontent;
          this.tableData = (this.jinjia==80||this.jinjia==40)?response.data.obj.seedgooddlist:response.data.obj.tablemaps;
          this.isyinxin=this.controlData.casestatus&&this.controlData.casestatus==100;
          for (let i in this.tableData) {
            this.tableData[i].P = 0
            if(this.jinjia==80){
              var pa=JSON.parse(this.tableData[i].packagesize)
              this.tableData[i].model = pa.M
              this.tableData[i].color = pa.C
              var bc = []
              if (this.tableData[i].barcodes) {
                var bcSpl=this.tableData[i].barcodes.split(';');
                for (let s in bcSpl) {
                  if (bcSpl[s])
                    bc.push({c: bcSpl[s]});
                }
              }
              this.tableData[i].barcodes=bc;
            }
          }

          if(this.jinjia==80) {
            for (let j in this.tableData) {
              var row = this.tableData[j];
              var cate = row.categorycode.substring(0, 9);
              var hasvalue = false;

              for (let i in this.frameSubTable) {
                if (cate == this.frameSubTable[i].cate&&row.costprice == this.frameSubTable[i].costprice) {
                  this.frameSubTable[i].totalnumber+=parseInt(row.totalnumber);
                  hasvalue = true;
                  break;
                }
              }
              if (!hasvalue) {
                this.frameSubTable.push({cate:cate,totalnumber:row.totalnumber,costprice:row.costprice,seedname:row.seedname.replace(row.model,'')})
              }

              ////////////////////////////////////////////////////////////////////////
              for (let i in this.frameTable) {
                if (cate == this.frameTable[i].cate) {
                  this.frameTable[i].data.push(row);
                  this.frameTable[i].totalnumber+=parseInt(row.totalnumber);
                  this.frameTable[i].costprice+=parseFloat(row.costprice)*parseInt(row.totalnumber);;
                  hasvalue = true;
                  break;
                }
              }
              if (!hasvalue) {
                var firstD = []
                firstD.push(row);
                this.frameTable.push({cate: cate, data: firstD, costprice: row.costprice*row.totalnumber, totalnumber: row.totalnumber})
              }


            }

            for (let i in this.frameTable) {
              this.frameTable[i].data.sort(function (a, b) {
                if (a.model == b.model)
                  return a.color.localeCompare(b.color);
                else
                  return a.model.localeCompare(b.model);
              });
            }

            this.frameSubTable.sort(function (a, b) {
                return a.seedname.localeCompare(b.seedname);
            });
          }

          if(this.jinjia==40) {
            this.showzuoyoutable = false
            this.showerweitable = false
            this.BookContent = [];
            this.totalNumber()

            if (this.isyinxin) {
              for (let i in this.tableData) {
                this.tableData[i].baritem = null
                if (!this.tableData[i].barcodes)
                  continue;

                var row = JSON.parse(this.tableData[i].barcodes)
                this.tableData[i].baritem = row
              }
            }

          }else {

            if (this.tableData && this.tableData.length > 0)
              this.totalNumber()

            if(this.isyinxin){//隐形显示
              this.showerweitable = true
              this.tableData=[];
              var item=response.data.obj.seedgooddlist;
              for(let i in item) {
                var row = JSON.parse(item[i].barcodes)
                row.totalnumber = item[i].totalnumber;
                var pg = JSON.parse(item[i].packagesize)
                row.X = pg.X;
                row.Y = pg.Y;
                row.packagesize = item[i].packagesize;
                this.tableData.push(row);
              }
              this.totalNumber();
              this.tableData.sort(function (a, b) {
                let aP = JSON.parse(a.packagesize)
                let bP = JSON.parse(b.packagesize)
                if (aP.X == bP.X) {
                  if(aP.Y=='0.00') aP.Y="-0.00";
                  if(bP.Y=='0.00') bP.Y="-0.00";
                  return aP.Y.localeCompare(bP.Y)
                }
                else {
                  if(aP.X=='0.00') aP.X="-0.00";
                  if(bP.X=='0.00') bP.X="-0.00";
                  return aP.X.localeCompare(bP.X)
                }
              })
              //排序
            }else {
              if (bookcontent && bookcontent.length > 0 && bookcontent[0].type) {
                this.showzuoyoutable = true
                this.showerweitable = false
                for (let i in bookcontent) {
                  if (bookcontent[i].type == "L") {
                    this.BookContentLeft.push(bookcontent[i])
                  }
                  if (bookcontent[i].type == "R") {
                    this.BookContentRight.push(bookcontent[i])
                  }
                }
              } else {
                this.showzuoyoutable = false
                this.showerweitable = true
                this.BookContent = bookcontent;
              }
            }
          }

          if (response.data.printlogDOList && response.data.printlogDOList.length > 0) {
            this.printData = response.data.printlogDOList
            this.uname = this.printData[0].uname
            this.adddate = this.printData[0].adddate
          }
          if (this.controlData.filltemplate != 80&&this.controlData.filltemplate != 40)
            this.getXYRange()
          //调拨单发货  查询订单是否有人正在操作
          if (opstatus == 'fahuo' && this.controlData.status == -10) {}
        });
      },
      getXYRange() {
        getPrice({seedcode: this.controlData.seedcode}).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }
          this.createPriceBook()
        })
      },
      createPriceBook() {
        if (this.showzuoyoutable) {
          this.$refs.referweibiaoleft.initBookFix(this.BookContentLeft)
          this.$refs.referweibiaoright.initBookFix(this.BookContentRight)
        }
        if (this.showerweitable) {
          this.$refs.referweibiao.initBookFix(this.BookContent)
        }
      },
      tips() {
        if (this.uname) {
          return "(打印人：" + this.uname + ",时间：" + this.adddate + ")"
        } else {
          return "(未打印过)"
        }
      },
      printlogsave() {
        // save({erpserial: this.controlData.erpserial}).then(response => {
        //   if (response.data.code == 0) {
        //     //this.initData(this.row);
        //     this.$message({
        //       message: '生成打印日志',
        //       type: 'success'
        //     })
        //   }
        // })
      },
      printloglook() {
        this.$refs.printlogList.show()
        this.$refs.printlogList.initData(this.controlData.erpserial);
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.column = []
        this.tableData = []
        this.isyinxin=false;
        this.unitguid = ""
        this.printData = []
        this.uname = ''
        this.adddate = ''
        //this.controlData.logisticsco = ""
        this.controlData.logisticsnum = ""

        this.BookContent = []
        this.BookContentLeft = []
        this.BookContentRight = []
        this.barcodeBookContent = []
        this.barcodeBookContentLeft = []
        this.barcodeBookContentRight = []
        this.isshowbarcode = false
        this.lock = true
        this.lockuname = ''
        this.jinjia = ''
        this.tableData = []
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      getParameterDetail({paraname: "快递公司"}).then(response => {
        var row = response.data.obj;
        if (row == null || row.paracontent == null) {//取全局的配置
          detailglob({paraname: "快递公司"}).then(resGlob => {
             if(resGlob.data.obj&&resGlob.data.obj.paracontent){
               this.parameterData = JSON.parse(resGlob.data.obj.paracontent);
               if (this.parameterData.length == 1)
                 this.controlData.logisticsco = this.parameterData[0].name
             }
          });
          return;
        }
        this.parameterData = JSON.parse(row.paracontent);
        if (this.parameterData.length == 1)
          this.controlData.logisticsco = this.parameterData[0].name
      })
    },
    components: {
      printlogList,
      HandlelogList,
      TwoDimensionalTable
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>





// WEBPACK FOOTER //
// src/components/warehouse/AllocationDetail.vue